import * as React from "react";
import { useCallback } from "react";
import { TableCell } from "@mzc-pdc/ui";
import { Grid } from "@mui/material";
import Skeleton from "@components_v2/skeleton/skeleton";

export const SkeletonCollectionsTable = ({ columns }) => {
    const getSkeletonByColumn = useCallback(
        (column) => {
            const { id: columnId, style } = column;

            if (!columnId) return;
            if (columnId === "name")
                return (
                    <Grid
                        container
                        direction={`row`}
                        justifyContent={`flex-start`}
                        alignItems={`center`}
                        flexWrap={"nowrap"}
                        width={`calc(100% - 30px)`}
                    >
                        <Grid item>
                            <Skeleton variant="rounded" animation={"wave"} width={52} height={52} sx={{ mx: 1.5 }} />
                        </Grid>
                        <Grid item flex={1}>
                            <Skeleton variant="rounded" animation={"wave"} width={"100%"} height={21} />
                        </Grid>
                    </Grid>
                );
            if (columnId === "count") return <Skeleton variant="rounded" animation={"wave"} width={30} height={18} />;
            return <Skeleton variant="rounded" animation={"wave"} width={style?.custom?.width ?? 100} height={18} />;
        },
        [columns],
    );

    return (
        <>
            <TableCell sx={{ width: "30px" }} padding="checkbox">
                <Skeleton variant="rounded" animation={"wave"} width={18} height={18} />
            </TableCell>
            {columns &&
                columns.map((column) => (
                    <TableCell
                        mt={1}
                        mb={1}
                        sx={{
                            ...{ width: column?.style?.custom?.width ?? undefined },
                        }}
                    >
                        {getSkeletonByColumn(column)}
                    </TableCell>
                ))}
        </>
    );
};

export default SkeletonCollectionsTable;
